import { createFileRoute } from '@tanstack/react-router'
import { DashboardShimmerLayout } from '~/components/Layout/DashboardShimmer'

export const Route = createFileRoute('/bridge')({
  component: () => <DashboardShimmerLayout />
})
